import { createSelector } from 'reselect'
import { AppGlobalState, Progress } from '../../types'
import { InventoryExchangeTransaction } from './types'
import { EntityMetadata } from 'modules/domain/types'

const dict = (state: AppGlobalState) => state.inventoryExchangeTransaction.items
const ids = (state: AppGlobalState) => state.inventoryExchangeTransaction.ids
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const item = (state: AppGlobalState, id: string): InventoryExchangeTransaction | undefined =>
  state.inventoryExchangeTransaction.items[id]
const meta = (state: AppGlobalState, id: string): EntityMetadata<InventoryExchangeTransaction> =>
  state.inventoryExchangeTransaction.meta[id] || {
    fetchError: null,
    fetchProgress: Progress.IDLE,
    id,
    removeError: null,
    removeProgress: Progress.IDLE,
    updateError: null,
    updateProgress: Progress.IDLE,
  }
const itemFetchProgress = (state: AppGlobalState) => state.inventoryExchangeTransaction.itemFetchProgress
const listFetchProgress = (state: AppGlobalState) => state.inventoryExchangeTransaction.listFetchProgress
const listFetchError = (state: AppGlobalState) => state.inventoryExchangeTransaction.listFetchError
const listFetchErrorDetail = (state: AppGlobalState) => state.inventoryExchangeTransaction.listFetchErrorDetail
const listFetchNextProgress = (state: AppGlobalState) => state.inventoryExchangeTransaction.listFetchNextProgress
const listFetchNextError = (state: AppGlobalState) => state.inventoryExchangeTransaction.listFetchNextError
const listFetchNextErrorDetail = (state: AppGlobalState) => state.inventoryExchangeTransaction.listFetchNextErrorDetail
const list = createSelector(dict, ids, listFetchProgress, (dict, ids, progress) => {
  if (progress === Progress.WORK) {
    return []
  }
  const result: InventoryExchangeTransaction[] = []
  for (const id of ids) {
    result.push(dict[id])
  }
  return result
})

const filter = (state: AppGlobalState) => state.inventoryExchangeTransaction.filter
const sorting = (state: AppGlobalState) => state.inventoryExchangeTransaction.sorting
const page = (state: AppGlobalState) => state.inventoryExchangeTransaction.page
const total = (state: AppGlobalState) => state.inventoryExchangeTransaction.total
const updateProgress = (state: AppGlobalState) => state.inventoryExchangeTransaction.updateProgress
const removeProgress = (state: AppGlobalState) => state.inventoryExchangeTransaction.removeProgress
const addProgress = (state: AppGlobalState) => state.inventoryExchangeTransaction.addProgress
const hasNext = (state: AppGlobalState) =>
  state.inventoryExchangeTransaction.total > state.inventoryExchangeTransaction.ids.length
const pageSize = (state: AppGlobalState) => state.inventoryExchangeTransaction.pageSize
const pages = (state: AppGlobalState) =>
  Math.ceil(state.inventoryExchangeTransaction.total / state.inventoryExchangeTransaction.pageSize)

const InventoryExchangeTransactionSelectors = {
  filter,
  sorting,
  page,
  total,
  updateProgress,
  removeProgress,
  addProgress,
  item,
  meta,
  itemFetchProgress,
  listFetchProgress,
  listFetchError,
  listFetchErrorDetail,
  list,
  dict,
  ids,
  hasNext,
  pageSize,
  listFetchNextProgress,
  listFetchNextError,
  listFetchNextErrorDetail,
  pages,
}

export default InventoryExchangeTransactionSelectors
